const normalizeContentItems = (items) => {
  const projects = Object.values(items).map((project) => {
    const { id, alias } = project;
    const formData = project['form_data'];

    return {
      id,
      alias,
      ...formData,
    }
  });

  // Фильтруем. Выводим только публикованные.
  return projects.filter((item) => Boolean(item.publish));
};

export const normalizeGalleryProject = (data = {}) => {
  if (!data) {
    return null;
  }

  const alias = 'gallery_projects';
  let projects = [];

  try {
    const items = data.data[alias].items;

    projects = normalizeContentItems(items);
  } catch (error) {
    console.error(error);

    projects = null;
  }

  return projects;
};

export const normalizeGalleryProjectTag = (data = {}) => {
  if (!data) {
    return null;
  }

  const aliases = {
    style: 'gallery_tags_style',
    room: 'gallery_tags_room',
    combo: 'gallery_tags_room_style',
  };

  let tags = {};

  try {
    for(let key in aliases) {
      if (Object.prototype.hasOwnProperty.call(aliases, key)) {
        tags[key] =  normalizeContentItems(data.data[aliases[key]].items);
      }
    }
  } catch (error) {
    console.error(error);

    tags = null;
  }

  return tags;
};

export const normalizeGalleryQuery = (query = {}, tags) => {
  const findCurrentTagType = (tag) => {
    for(let key in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, key)) {
        const arrayAddress = tags[key].map(item => item.address.toLowerCase());

        if (arrayAddress.indexOf(tag.toLowerCase()) !== -1) {
          return key;
        }
      }
    }
  };
  const queryTags = {};

  if (query.tag && query.style) {
    queryTags['room'] = query.tag;
    queryTags['style'] = query.style;
  } else if (query.tag) {
    const type = findCurrentTagType(query.tag, tags) || 'room';

    queryTags[type] = query.tag;
  }

  if (query.rm) {
    queryTags['rm'] = query.rm.split(',');
  }

  if (query.st) {
    queryTags['st'] = query.st.split(',');
  }

  return queryTags;
};
